import Link from 'next/link';
import { useSearchParams } from 'next/navigation';

import { Anchor, SimpleGrid, Text } from '@mantine/core';

import { CompanyProfile, PermissionCompany } from 'models';
import { CompanyHelpers } from 'helpers/CompanyHelpers';

import { useProfilePermission } from 'components/company-profile/hooks/use-profile-permission';

const RequestAccess = ({ company }: { company: CompanyProfile }) => {
    const search = useSearchParams();
    const canEdit = useProfilePermission(PermissionCompany.EDIT);
    const isPreviewUrl = search?.get('preview');

    // Unclaimed profiles already offer "Claim this profile" in UnclaimedProfileDisclaimer
    if (canEdit || isPreviewUrl || company.internal) return null;

    return (
        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md" verticalSpacing="xs" maw={720} mx="auto" mb="xl">
            <Text fz="xs" c="dimmed" ta="center">
                Do you work at {company.name}?{' '}
                <Anchor
                    inherit
                    c="dimmed"
                    td="underline"
                    component={Link}
                    href={CompanyHelpers.urls.requestAccess(company.slug)}
                >
                    Request access
                </Anchor>
            </Text>
            <Text fz="xs" c="dimmed" ta="center">
                Spotted incorrect information?{' '}
                <Anchor
                    inherit
                    c="dimmed"
                    td="underline"
                    href={CompanyHelpers.urls.reportIncorrectInformation(company.name)}
                >
                    Let us know
                </Anchor>
                .
            </Text>
        </SimpleGrid>
    );
};

export { RequestAccess };
